import c from 'classnames';

import { Icon, Typography } from '@repo/ui';

import styles from './LoadingLabel.module.css';

interface LoadingLabelProps {
  className?: string;
}

export const LoadingLabel = ({ className }: LoadingLabelProps) => {
  return (
    <div className={c(styles.loadingLabel, className)}>
      <Icon name='aiGradient' size='s' preserveColors />
      <Typography variant='eyebrow' className={styles.gradientText}>
        Referencing our knowledge base...
      </Typography>
    </div>
  );
};
